module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.3e5675c89f974f7811ee.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.woff
// module chunks = 1